import {
  ASSIGN_CASE_TO_USER,
  ASSIGN_CASE_TO_USER_SUCCESS,
  ASSIGN_CASE_TO_USER_FAIL,
  ASSIGN_CASE_ACTION_INFO_MODAL_CLOSE,
  ASSIGN_CASE_TO_USER_RESET
} from '../../actions/cm/caseList';

export const initialState = {
  showInfoModal: false,
  isLoading: false,
  hasError: false,
  message: ''
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case ASSIGN_CASE_TO_USER:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        message: ''
      };
    case ASSIGN_CASE_TO_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showInfoModal: true
      };
    case ASSIGN_CASE_TO_USER_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        message: payload.message
      };
    case ASSIGN_CASE_ACTION_INFO_MODAL_CLOSE:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        showInfoModal: false
      };
    case ASSIGN_CASE_TO_USER_RESET:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        message: ''
      };
    default:
      return state;
  }
}
